import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/caspianentertain/amburan.caspianentertainment.com/node_modules/next/dist/client/app-dir/link.js");
